import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { cleanNotification } from '../../store/features/notification/notificationSlice'
import { NotificationContainer } from './styles'

type NotificationProps = {
  text: string,
  btnText?: string,
  action?: () => void
}

function Notification({ text, btnText, action }: NotificationProps) {
  const notificationRef = useRef<HTMLDivElement>(null)

  const { storeParams } = useSelector((state: RootState) => state.token)

  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      notificationRef.current?.classList.add('going_out')
    }, 2000)

    setTimeout(() => {
      dispatch(cleanNotification())
    }, 2500)
  }, [])

  return (
    <NotificationContainer background={storeParams.bgColor ? `#${storeParams.bgColor}` : '#ff0000'} ref={notificationRef}>
      <p>{text}</p>
      {
        btnText && action && (
          <button onClick={action}>{btnText}</button>
        )
      }
    </NotificationContainer>
  )
}
export default Notification
